<template>
  <div class="h-full flex flex-col">
    <div
      class="px-5 h-12 w-full flex bg-white border-b border-orange-lighter items-center text-black"
    >
      <SettingsSM />
    </div>
    <perfect-scrollbar class="content-area">
      <router-view
        class="p-5 min-h-full bg-white border-l border-r"
      ></router-view>
    </perfect-scrollbar>
  </div>
</template>

<script>
import SettingsSM from "./SettingsSM";
export default {
  name: "Settings",
  components: { SettingsSM },
};
</script>
